// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";

const useShowMyListDetailsCategoryView = () => {
    const showMyListDetailCategoryView = useAppSelector(
        state => state.bunzl.pages.myListDetailsCategory.showCategoryView,
    );
    return showMyListDetailCategoryView;
};

export default useShowMyListDetailsCategoryView;
